import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import type { SxProps, Theme } from '@mui/material/styles'
import type { ElementType } from 'react'

interface Props {
  text: string
  placement?: 'top' | 'top-start' | 'bottom' | 'bottom-start'
  typographySx?: SxProps<Theme>
  component?: ElementType
  'data-testid'?: string
}

/**
 * Single-line ellipsis with full text in a tooltip.
 * Tooltip children must be block-level with minWidth: 0 so flex parents can shrink them.
 */
export function TruncatedTooltipText({
  text,
  placement = 'top-start',
  typographySx,
  component = 'span',
  'data-testid': dataTestId,
}: Readonly<Props>) {
  return (
    <Tooltip title={text} placement={placement}>
      <Box
        component="span"
        sx={{
          display: 'block',
          minWidth: 0,
          maxWidth: '100%',
          overflow: 'hidden',
        }}
      >
        <Typography
          component={component}
          noWrap
          data-testid={dataTestId}
          sx={{
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            minWidth: 0,
            ...typographySx,
          }}
        >
          {text}
        </Typography>
      </Box>
    </Tooltip>
  )
}
